import * as MuiIcons from "@mui/icons-material";
import { Euro } from "@mui/icons-material";
import * as Mui from '@mui/material';
import { Grid, InputAdornment } from '@mui/material';
import { useEffect } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import FormTextField from "../../../experiments/forms/FormTextField";
import { usePaymentRequestRepository } from "../../../api/repositories/PaymentRequestRepository";
import { useRecoilState } from "recoil";
import { STATE_MODAL_UPDATING } from "./atoms/PaymentRequestAtoms";

interface Props {
  open: boolean;
  id: any;
  amountRecovered: any;
  amountRecoveredDescr: any;
  onClose: () => void;
}

const EditAmount = (props: Props) => {

  const { t } = useTranslation('finance', { keyPrefix: 'payments.payment-request' });
  const [updating, setUpdating] = useRecoilState(STATE_MODAL_UPDATING);
  const schema = Yup.object().shape({
    amountRecovered: Yup.string().nullable().required().default(t('modal.amount-required-error')),
    //amountRecoveredDescr: Yup.string().nullable().required(t('required-error')).max(7)
  });

  const { putAmountById } = usePaymentRequestRepository();
  const { handleSubmit, control, setValue, trigger } = useForm<any>({
    defaultValues: {
      amountRecovered: "",
      amountRecoveredDescr: ""
    },
    resolver: yupResolver(schema),
  });

  async function renderNotes() {
    if (props?.amountRecovered) {
      setValue('amountRecovered', props.amountRecovered / 100);
      trigger('amountRecovered');
    }
    if (props?.amountRecoveredDescr) {
      setValue('amountRecoveredDescr', props.amountRecoveredDescr);
      trigger('amountRecoveredDescr');
    }
  }


  useEffect(() => {
    renderNotes();
  }, [props]);

  const onSubmit: SubmitHandler<any> = (data) => {
    data.amountRecovered = data.amountRecovered * 100;
    putAmountById(props.id, data).then(() => {
      setUpdating(true);
      onClose();
    });
  }

  const onClose = () => {
    props.onClose();
  };

  return (
    <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="md">
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Mui.DialogTitle>
          <Mui.Grid container alignItems="center">
            <Mui.Grid item xs="auto">
              <Mui.Typography variant="h6">
                {t("modal.amount-title")}
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid item xs="auto" marginLeft="auto">
              <Mui.IconButton onClick={onClose}>
                <MuiIcons.Close />
              </Mui.IconButton>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogTitle>
        <Mui.DialogContent>
          <Grid container spacing={2}>

            <Grid item xs={6}>
              <FormTextField
                name={`amountRecovered`}
                control={control}
                props={{
                  label: t('modal.amount'),
                  fullWidth: true,
                  sx: { width: '100%' },
                  type: "number",
                  InputProps: {
                    startAdornment:
                      <InputAdornment position="start">
                        <Euro style={{ fontSize: '15px' }} />
                      </InputAdornment>

                  },
                }}
              />
            </Grid>
            <Grid item xs={6}>
              <FormTextField
                name={`amountRecoveredDescr`}
                control={control}
                props={{
                  label: t('modal.description'),
                  fullWidth: true,
                  sx: { width: '100%' }
                }}
              />
            </Grid>

          </Grid>

        </Mui.DialogContent>
        <Mui.DialogActions>
          <Mui.Grid container justifyContent="end" spacing="16px">
            <Mui.Grid item xs="auto" height='48px'>
              <Mui.Button variant="outlined" size="medium" sx={{ maxWidth: '111px', minWidth: "111px", fontWeight: 700 }} onClick={onClose}>
                {t(
                  "modal.actionButtons.cancel"
                )}
              </Mui.Button>
            </Mui.Grid>
            <Mui.Grid item xs="auto">
              <Mui.Button type="submit" size="medium" sx={{ maxWidth: '111px', minWidth: "111px", fontWeight: 700 }} >
                {t("modal.actionButtons.save")}
              </Mui.Button>
            </Mui.Grid>
          </Mui.Grid>
        </Mui.DialogActions>

      </form>
    </Mui.Dialog>

  );
};

export default EditAmount;



